import React, { useEffect } from "react";
import { formatLeadTime } from "../utils/formatters";

function Confirmation({
  cart,
  store,
  onUpdateQuantity,
  onRemoveItem,
  onProceed,
  theme,
  total,
  discount,
  deliveryFee,
  onBack,
  shippingMethod,
  deliveryOption,
  deliveryAddress,
  deliveryCity,
  deliveryState,
  deliveryDate,
  deliveryTime,
  totalDriveTime,
  pickupDate,
  pickupTime,
  tax,
  productTotal,
  formattedDeliveryAddress,
  routeDetails,
}) {
  useEffect(() => {
    if (totalDriveTime !== undefined && totalDriveTime !== null) {
      console.log("Total Drive Time:", totalDriveTime);
    }
  }, [totalDriveTime]);

  // Function to format delivery date into Weekday, MM/DD
  const formatDeliveryDate = (date) => {
    if (!date) return ""; // Handle empty or null date
    
    // Split the date string and create a date at noon local time
    const [year, month, day] = date.split('-').map(Number);
    const parsedDate = new Date(year, month - 1, day, 12, 0, 0);
    
    return parsedDate.toLocaleString("en-US", {
      weekday: "long",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    title: { color: theme.primaryFontColor, fontSize: "20px", marginBottom: "20px" },
    table: {
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
    },

    th: {
      color: theme.primaryFontColor,
      textAlign: "left",
      paddingBottom: "20px",
    },
    td: {
      textAlign: "left",
      color: "black",
      fontSize: 12,
      fontWeight: "bold",
    },
    input: {
      width: "50px",
      padding: "5px",
      backgroundColor: theme.backgroundColor,
      color: "black",
      border: `1px solid ${theme.primaryFontColor}`,
      borderRadius: "5px",
      fontSize: 12,
      textAlign: "center",
    },
    removeButton: {
      backgroundColor: "#dc3545",
      color: "white",
      border: "none",
      padding: "5px 10px",
      borderRadius: "5px",
      cursor: "pointer",
    },
    button: {
      backgroundColor: theme.accentColor,
      color: "white",
      border: "none",
      padding: "10px 15px",
      borderRadius: "5px",
      cursor: "pointer",
      width: 150,
    },
    footer: {
      position: "absolute",
      bottom: "0",
      left: "0",
      right: "0",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "white",
      borderTop: "1px solid #ccc",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    },
    subtotal: {
      // position: "absolute",
      // bottom: "0",
      // left: "0",
      // right: "0",
      color: theme.primaryFontColor,
      marginRight: 20,
      fontSize: 14,
      // fontWeight: "bold",
      marginTop: -7,
    },
    shipping: {
      color: "black",
      fontSize: 14,
      marginTop: -7,
    },
    subtotalContainer: {
      display: "flex",
      alignSelf: "flex-end",
      flexDirection: "column",
      flex: "1 1 200px", // Allow growing up to maxWidth
      marginBottom: 100,
      marginLeft: "10px",
    },
    subtotalRow: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: "5px",
      width: "100%", // Ensure row takes full width of container
    },
    subtotalLabel: {
      textAlign: "left",
      marginRight: "10px",
      flex: "1 1 auto",
      minWidth: "0",
    },
    subtotalValue: {
      textAlign: "right",
      flex: "0 0 auto",
    },
    deliveryContainer: {
      textAlign: "left",
      flex: "1 0 auto",
      marginRight: "10px",
      minWidth: "0",
    },
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Confirmation</h3>
      <div
        name="divider"
        style={{
          backgroundColor: theme.primaryFontColor,
          height: 1,
          marginBottom: 20,
        }}
      />
      <table style={{ ...styles.table, tableLayout: "fixed", width: "100%" }}>
        <thead>
          <tr style={{ display: "table", width: "100%", tableLayout: "fixed", height: "27px" }}>
            <th
              style={{
                ...styles.th,
                width: "45%",
                minWidth: "60px",
                paddingLeft: "10px",
              }}
            >
              Item
            </th>
            <th
              style={{
                ...styles.th,
                width: "25%",
                minWidth: "50px",
                textAlign: "center",
              }}
            >
              Quantity
            </th>
            <th
              style={{
                ...styles.th,
                width: "20%",
                minWidth: "50px",
                textAlign: "center",
              }}
            >
              Lead Time
            </th>
            <th
              style={{
                ...styles.th,
                width: "10%",
                minWidth: "30px",
                textAlign: "right",
              }}
            >
              Price
            </th>
          </tr>
        </thead>
      </table>

      <div
        name="scrollable-content"
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1, // Allow the scrollable content to take the remaining height
          overflowY: "auto", // Enable vertical scrolling
          // padding: "10px",
          paddingBottom: 125,
          width: "100%", // Ensure the content adjusts to window width
        }}
      >
        <div
          style={{
            maxHeight: "200px",
            // overflowY: "auto",
          }}
        >
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              marginBottom: "20px",
            }}
          >
            <table
              style={{ ...styles.table, tableLayout: "fixed", width: "100%" }}
            >
              <tbody>
                {cart.map((item) => (
                  <tr
                    key={item.sku}
                    style={{
                      display: "table",
                      width: "100%",
                      tableLayout: "fixed",
                      height: "27px",
                    }}
                  >
                    <td
                      style={{
                        ...styles.td,
                        width: "45%",
                        minWidth: "60px",
                        paddingLeft: "10px",
                      }}
                    >
                      {item.title}
                    </td>
                    <td
                      style={{
                        ...styles.td,
                        width: "25%",
                        minWidth: "50px",
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{...styles.input, border: 'none', backgroundColor: 'transparent'}}
                      >
                        {item.quantity}
                      </span>
                    </td>
                    <td
                      style={{
                        ...styles.td,
                        width: "20%",
                        minWidth: "20px",
                        textAlign: "center",
                      }}
                    >
                      {formatLeadTime(item.lead_time_hours)}
                    </td>
                    <td
                      style={{
                        ...styles.td,
                        width: "10%",
                        minWidth: "30px",
                        textAlign: "right",
                      }}
                    >
                      $
                      {Number(
                        item.retail_price.replace(/,/g, "") * item.quantity
                      ).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingTop: 18,
          }}
        >
          <div
            name="delivery-container"
            style={styles.deliveryContainer}
          >
            {shippingMethod === "deliver" ? (
              <>
                <p
                  style={{
                    ...styles.shipping,
                    fontWeight: "600",
                    color: theme.primaryFontColor,
                  }}
                >
                  Delivery Details
                </p>
                <p style={styles.shipping}>
                  Delivery Address:{" "}
                  {window.innerWidth < 500 && <br />}
                  <strong style={{ color: theme.primaryFontColor }}>
                    {formattedDeliveryAddress.split(",").slice(0, 2).join(",")},{" "}
                    {
                      formattedDeliveryAddress
                        .split(",")[2]
                        ?.trim()
                        .split(" ")[0]
                    }
                  </strong>
                </p>
                {deliveryOption === "asap" ? (
                  <p style={styles.shipping}>
                    Estimated Arrival:{" "}
                    {window.innerWidth < 500 && <br />}
                    <strong style={{ color: theme.accentColor }}>
                      {routeDetails && routeDetails["delivery-deadline"]
                        ? routeDetails["delivery-deadline"]
                        : totalDriveTime < 30
                        ? "35 minutes"
                        : totalDriveTime >= 30 && totalDriveTime <= 60
                        ? "1 hour"
                        : `${(
                            Math.round(totalDriveTime / 60 / 0.5) * 0.5
                          ).toFixed(1)} hour(s)`}
                    </strong>
                  </p>
                ) : (
                  <p style={styles.shipping}>
                    Estimated Arrival:{" "}
                    {window.innerWidth < 500 && <br />}
                    <strong style={{ color: theme.primaryFontColor }}>
                      {deliveryTime} {formatDeliveryDate(deliveryDate)}
                    </strong>
                    {/* Example tax rate of 10% */}
                  </p>
                )}
              </>
            ) : (
              <>
                <p
                  style={{
                    ...styles.shipping,
                    fontWeight: "600",
                    color: theme.primaryFontColor,
                  }}
                >
                  Pickup Details
                </p>
                <p style={styles.shipping}>
                  Scheduled Pickup:{" "}
                  {window.innerWidth < 500 && <br />}
                  <strong style={{ color: theme.primaryFontColor }}>
                    {pickupTime} {formatDeliveryDate(pickupDate)}
                  </strong>
                </p>
                <p style={styles.shipping}>
                  Location:{" "}
                  {window.innerWidth < 500 && <br />}
                  <strong style={{ color: theme.primaryFontColor }}>
                    {store.address} {store.city}, {store.state}
                  </strong>
                </p>
              </>
            )}
          </div>

          <div
            name="subtotal-container"
            style={styles.subtotalContainer}
          >
            <div style={styles.subtotalRow}>
              <p style={{...styles.shipping, ...styles.subtotalLabel}}>
                Product Subtotal:
              </p>
              <p style={{...styles.shipping, ...styles.subtotalValue}}>
                <strong style={{ color: theme.primaryFontColor }}>
                  ${(productTotal)?.toFixed(2) || "0.00"}
                </strong>
              </p>
            </div>

            <div style={styles.subtotalRow}>
              <p style={{...styles.shipping, ...styles.subtotalLabel}}>
                Discount:
              </p>
              <p style={{...styles.shipping, ...styles.subtotalValue}}>
                <strong style={{ color: theme.primaryFontColor }}>
                  - ${discount?.toFixed(2) || "0.00"}
                </strong>
              </p>
            </div>

            <div style={{...styles.subtotalRow, marginBottom: "0px"}}>
              <p style={{...styles.shipping, ...styles.subtotalLabel}}>
                Tax:
              </p>
              <p style={{...styles.shipping, ...styles.subtotalValue}}>
                <strong style={{ color: theme.primaryFontColor }}>
                  ${tax.toFixed(2)}
                </strong>
              </p>
            </div>

            <div style={styles.subtotalRow}>
              <p style={{...styles.shipping, ...styles.subtotalLabel}}>
                Delivery Fee:
              </p>
              <p style={{...styles.shipping, ...styles.subtotalValue}}>
                <strong style={{ color: theme.primaryFontColor }}>
                  ${deliveryFee.toFixed(2)}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.footer}>
        <div style={{ flex: 2, textAlign: "right" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              justifySelf: "flex-end",
            }}
          >
            <div
              style={{
                width: "35%",
              }}
            />
            <h4
              style={{
                color: "black",
                marginBottom: "10px",
                fontWeight: "400",
              }}
            >
              Order Total:
            </h4>
            <h4
              style={{
                color: theme.primaryFontColor,
                marginBottom: "10px",
                textAlign: "right",
              }}
            >
              ${total.toFixed(2)}
            </h4>
          </div>

          <div
            style={{
              // backgroundColor: "red",
              // width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <button style={styles.button} onClick={onBack}>
              Back
            </button>
            <button style={styles.button} onClick={onProceed}>
              Confirm & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
